export default __webpack_public_path__ + "static/media/file-docs.e16c5e4b.svg";